export default function Textfield() {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root.Mui-disabled': {
            pointerEvents: 'none',
          },
        },
      },
    },
  };
}
